import { TextField, Typography } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import ContractTermSection from "components/request-document/components/ContractTermSection";
import JobSection from "components/request-document/components/JobSection";
import WorkExperienceSection from "components/request-document/components/WorkExperienceSection";
import { useFormik } from "formik";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultJobTable,
  defaultWorkExperience,
  getDefaultRow,
  getErrorMessage,
  isError,
  mapJobTable,
  mapWorkExperience,
} from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStep2() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const canEdit = useSelector(canEditForm);
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );

  const ConditionType = get(smartformDetail, "ConditionType.value", "");
  const isGovernment = !(
    ConditionType === "Start up" || ConditionType === "Company"
  );
  const personalId = get(personalDetail, "personalID", "");
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);
  const countryConfig = get(masterData, "countryConfig", []);

  const detailList = [
    // "JobPosition",
    // "JobSubPosition",
    // "JobDescription",
    "JobTable",
    "ContractTermType",
    "ContractYear",
    "ContractMonth",
    "ContractPeriodFrom",
    "ContractPeriodTo",
    "ContractOther",
    "AverageIncomeBaht",
    "SalaryBaht",
    "OrtherIncome",
    "Allowance",
    "Benefit",
    "Bonus",
    "ContactPersonInThai",
    "ContactRelationship",
    "ContactEmail",
    "ContactMobile",
    "WorkExperience",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        JobPositionConfig: true,
        CountryConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          if (isGovernment) {
            dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
          } else {
            dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
          }
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isGovernment, isSaveDraft]);

  const callAPISubmit = async (values) => {
    showLoading();

    const contractTermTypeAllList = [
      "ContractYear",
      "ContractMonth",
      "ContractPeriodFrom",
      "ContractPeriodTo",
      "ContractOther",
    ];
    const contractTermTypeList = {
      Y: ["ContractYear", "ContractMonth"],
      P: ["ContractPeriodFrom", "ContractPeriodTo"],
      O: ["ContractOther"],
    };
    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values);
    const getFieldListConfig = defaultType.filter((field) =>
      [
        ...documentFields.filter((v) => !contractTermTypeAllList.includes(v)),
        ...contractTermTypeList[values.ContractTermType],
      ].includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "WorkExperience": {
          const workExperience = get(values, field.smartName, []);
          console.log("workExperience => ", workExperience);
          const value = workExperience.filter((v) => !!v.WorkOrganization);
          console.log("workExperience => ", value);
          return value || null;
        }
        case "JobTable": {
          const jobTable = get(values, field.smartName, []);
          const value = jobTable.filter((v) => !!v.jobTitle);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: null,
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    console.log("values.document => ", values.document);
    console.log("prepareData => ", prepareData);

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({
    // ContactEmail: yup.string().email("Invalid email format"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      // JobPosition: get(detail, "JobPosition.value", ""),
      // JobSubPosition: get(detail, "JobSubPosition.value", ""),
      // JobDescription: get(detail, "JobDescription.value", ""),
      JobTable: getDefaultRow(detail, "JobTable.value", defaultJobTable).map(
        mapJobTable
      ),
      // Term
      ContractTermType: get(detail, "ContractTermType.value", "Y"),
      ContractYear: get(detail, "ContractYear.value", ""),
      ContractMonth: get(detail, "ContractMonth.value", ""),
      ContractPeriodFrom: get(detail, "ContractPeriodFrom.value", ""),
      ContractPeriodTo: get(detail, "ContractPeriodTo.value", ""),
      ContractOther: get(detail, "ContractOther.value", ""),
      // --
      AverageIncomeBaht: get(detail, "AverageIncomeBaht.value", ""),
      SalaryBaht: get(detail, "SalaryBaht.value", ""),
      OrtherIncome: get(detail, "OrtherIncome.value", ""),
      Allowance: get(detail, "Allowance.value", ""),
      Benefit: get(detail, "Benefit.value", ""),
      Bonus: get(detail, "Bonus.value", ""),
      ContactPersonInThai: get(detail, "ContactPersonInThai.value", ""),
      ContactRelationship: get(detail, "ContactRelationship.value", ""),
      ContactEmail: get(detail, "ContactEmail.value", ""),
      ContactMobile: get(detail, "ContactMobile.value", ""),
      WorkExperience: getDefaultRow(
        detail,
        "WorkExperience.value",
        defaultWorkExperience
      ).map(mapWorkExperience),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “E”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part A : Personal Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <div className={classes.flexRow}>
                      <Bagde number={18} />
                      <InputLabel>Job position</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        style={{ marginLeft: 16, width: 300 }}
                        fullWidth
                      >
                        <InputLabel>Selected Job position</InputLabel>
                        <Select
                          label="Selected Job position"
                          name="JobPosition"
                          value={formik.values.JobPosition}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                        >
                          {jobPositionConfig.map((jobPosition) => (
                            <MenuItem
                              key={jobPosition.jobID}
                              value={jobPosition.jobID}
                            >
                              {jobPosition.jobName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        style={{ marginLeft: 16, width: 300 }}
                        fullWidth
                      >
                        <InputLabel>Selected Job Sub position</InputLabel>
                        <Select
                          label="Selected Job Sub position"
                          name="JobSubPosition"
                          value={formik.values.JobSubPosition}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                        >
                          {jobSubPositionConfig.map((jobPosition) => (
                            <MenuItem
                              key={jobPosition.jobsubID}
                              value={jobPosition.jobsubID}
                            >
                              {jobPosition.jobsubName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={19} />
                    <div className={classes.wrapField}>
                      <InputLabel>Job description</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="JobDescription"
                        value={formik.values.JobDescription}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("JobDescription", formik)}
                        helperText={getErrorMessage("JobDescription", formik)}
                        multiline
                        rows={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow> */}

              <JobSection formik={formik} />
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={22} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Contract term
                      </Typography>
                      <ContractTermSection formik={formik} isSmartForm />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={23} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Average income per month* (Baht)
                      </Typography>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="AverageIncomeBaht"
                        type="number"
                        value={formik.values.AverageIncomeBaht}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("AverageIncomeBaht", formik)}
                        helperText={getErrorMessage(
                          "AverageIncomeBaht",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Salary (Baht per month)</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        className={classes.textField}
                        variant="outlined"
                        name="SalaryBaht"
                        type="number"
                        value={formik.values.SalaryBaht}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("SalaryBaht", formik)}
                        helperText={getErrorMessage("SalaryBaht", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Allowance</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Allowance"
                        value={formik.values.Allowance}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Allowance", formik)}
                        helperText={getErrorMessage("Allowance", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Benefit</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Benefit"
                        value={formik.values.Benefit}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Benefit", formik)}
                        helperText={getErrorMessage("Benefit", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Bonus</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Bonus"
                        value={formik.values.Bonus}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Bonus", formik)}
                        helperText={getErrorMessage("Bonus", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Other items of income (Please specify)
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="OrtherIncome"
                        value={formik.values.OrtherIncome}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrtherIncome", formik)}
                        helperText={getErrorMessage("OrtherIncome", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={24} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Name of contact person in Thailand
                      </Typography>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ContactPersonInThai"
                        value={formik.values.ContactPersonInThai}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactPersonInThai", formik)}
                        helperText={getErrorMessage(
                          "ContactPersonInThai",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Relationship with the applicant</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ContactRelationship"
                        value={formik.values.ContactRelationship}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactRelationship", formik)}
                        helperText={getErrorMessage(
                          "ContactRelationship",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ContactEmail"
                        value={formik.values.ContactEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactEmail", formik)}
                        helperText={getErrorMessage("ContactEmail", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Phone number</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ContactMobile"
                        type="number"
                        value={formik.values.ContactMobile}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactMobile", formik)}
                        helperText={getErrorMessage("ContactMobile", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <WorkExperienceSection
                defaultWorkExperience={mapWorkExperience(defaultWorkExperience)}
                formik={formik}
                bagde={25}
              />
              <TableRow />
              <div />
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            marginTop: 44,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <InputLabel>
            Note: Supplementary sheets may be attached if additional space is
            required *Income may include items beyond salary i.e. allowances,
            commissions which need to be appeared on the evidence of contract or
            the certification letter
          </InputLabel>
        </div>

        <ButtonController
          onClickSaveDraft={() => {

            if (!canEdit) {
              if (isGovernment) {
                dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
              } else {
                dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
              }
            }


            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
